import { z } from 'zod'

import { RecurringType } from '../constants/recurring'

const recurringEndDateSchema = z.preprocess(
  (value) => (value === '' ? undefined : value),
  z.coerce.date().nullish()
)

export const recurringSchema = z.object({
  identifier: z.string().nullish(),
  enable: z.boolean().nullish(),
  config: z
    .object({
      type: z.nativeEnum(RecurringType),
      days: z.array(z.number().min(0).max(6)),
      block: z.number().min(1).default(1),
      endDate: recurringEndDateSchema,
    })
    .partial()
    .nullish(),
})
